import Mapper from './Mapper';

export default class DictionaryMapper extends Mapper<Dictionary, DictionaryDTO> {
  constructor() {
    super({ name: 'name', entries: 'entries' });
  }

  public responseDTOToModel = (dictionary: DictionaryDTO): Dictionary => {
    return {
      ...this.responseDTOToModelViaDiffMap(dictionary),
      entries: dictionary.entries.map((e) => {
        return { name: e.name, id: e.key };
      }),
    };
  };

  public contractTypesResponseDTOToModel = (contractType: OrderContractType) => {
    return {
      id: contractType.id,
      code: contractType.code,
      name: contractType.name,
    };
  };
}
